export default __webpack_public_path__ + "static/media/img_I_Am_Homeowner.eff3916a.svg";